<template>
  <div id="main-content" class="edit-bus">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form v-if="busInfo">
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('bus.name') }}</span>
            </el-col>
            <input class="input" v-model="busInfo.name" type=""/>
            <el-col v-if="error_message.name" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.name" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col  :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('bus.brand') }}</span>
            </el-col>
            <input class="input" v-model="busInfo.brand" type=""/>
            <el-col v-if="error_message.brand" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.brand" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('bus.form') }}</span>
            </el-col>
            <select style="" class="input" v-model="busInfo.layout_id">
              <option value="">{{ $t('common.please_select') }}</option>
              <option v-for="layout in busLayoutList" :key="layout.id" :value="layout.id">{{ `${layout.name}, ${$t('bus.total_seat')}: ${layout.total_seats}` }} </option>
            </select>
            <el-col v-if="error_message.layout_id" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.layout_id" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col  :span="12" style="display: inline;">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('bus.total_allowed_seats') }}</span>
            </el-col>
            <input class="input" v-model="busInfo.available_seats" type=""/>
            <el-col v-if="error_message.available_seats" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.available_seats" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('bus.license_plate') }}</span>
            </el-col>
            <select style="" class="input" v-model="busInfo.license_plate">
              <option :value="busInfo.license_plate">{{ busInfo.license_plate }}</option>
              <option v-for="plate in plateList" :key="plate" :value="plate">{{ plate }} </option>
            </select>
            <el-col v-if="error_message.license_plate" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.license_plate" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col  :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('bus.owner_type') }}</span>
            </el-col>
            <b-form-select
              id="input-3"
              style="width: 60%; float: left"
              v-model="busInfo.ownership_type"
              :options="owner_type"
              required
            ></b-form-select>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.year') }}</span>
            </el-col>
            <input class="input" v-model="busInfo.manufacture_year" type=""/>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.image') }}</span>
            </el-col>
            <b-form-file
              v-model="busInfo.image"
              style="width: 60%; float: left"
              :placeholder="$t('common.choose_file')"
              :drop-placeholder="$t('common.drop_file')"
            ></b-form-file>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('bus.purchase_time') }}</span>
            </el-col>
            <el-date-picker
                v-model="busInfo.buy_at"
                type="date"
                :placeholder="$t('common.pick_a_date')"
                value-format="yyyy-MM-dd" style="width: 60%; float: left;">
            </el-date-picker>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('bus.rear_camera') }}</span>
            </el-col>
            <el-col :span="15">
              <input type="checkbox" v-model="busInfo.has_rear_camera" name="" />
            </el-col>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('bus.service_start_time') }}</span>
            </el-col>
            <el-date-picker
                v-model="busInfo.used_at"
                type="date"
                :placeholder="$t('common.pick_a_date')"
                value-format="yyyy-MM-dd" style="width: 60%; float: left;">
            </el-date-picker>
          </el-col>
          <el-col  :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('bus.months_of_service_use') }}</span>
            </el-col>
            <input class="input" disabled="disabled" v-model="monthDiff" type=""/>
          </el-col>
        </el-row>
        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '../../components/PageTitle.vue'
  import { mapState } from 'vuex'

  export default {
    name: "EditBus",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/bus/detail?bid=${this.$route.query.bid}`,
        title: this.$t('bus.edit_bus'),
        owner_type: [{text: this.$t('bus.owned'), value: 1}, {text: this.$t('bus.rented'), value: 2}],
        error_message: {
          name: [],
          brand: [],
          available_seats: [],
          license_plate: [],
          layout_id: []
        },
        busInfo: null
      }
    },
    mounted: function () {
      let successCallback = (response) => {
        this.busInfo = Object.assign({}, response.data.data.bus_info)
      };
      let payload = {
        successCallback,
        bus_id: this.$route.query.bid
      }
      this.$store.dispatch('bus/getBusInfo', payload)
      this.$store.dispatch('bus/getBusLayoutList', payload)
      this.$store.dispatch('bus/getAvailablePlateList',)
    },
    computed: {
      ...mapState('bus', ['busInfo', 'busLayoutList', 'plateList']),
      monthDiff: function () {
        var months;
        var d1 = new Date(this.busInfo.used_at)
        var d2 = new Date()
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth() + 1;
        months += d2.getMonth();
        return months <= 0 ? 0 : months;
      }
    },
    methods: {
      submitAction: function () {
        var check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push({path: '/bus/detail', query: {bid: this.$route.query.bid}});
          }
          var formData = new FormData()
          for (const [key, value] of Object.entries(this.busInfo)) {
            if (key === "seats") {
              formData.append(key, this.busLayoutList.find(x => x.id === this.busInfo.layout_id).total_seats)
            } else {
              formData.append(key, typeof value === 'boolean' ? value ? 1 : 0 : value)
            }
          }

          let payload = {
            successCallback,
            data: formData,
            bus_id: this.$route.query.bid
          }

          this.$store.dispatch('bus/editBus', payload);
        } else {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })
          return false
        }
      },
      validate: function () {
        var check = true
        this.error_message.name = []
        if (this.busInfo.name === "") {
          this.error_message.name.push('* ' + this.$t('bus.bus_name_is_required'))
          check = false
        }

        this.error_message.brand = []
        if (this.busInfo.brand === "") {
          check = false
          this.error_message.brand.push('* ' + this.$t('bus.brand_is_required'))
        }
        this.error_message.layout_id = []
        if (this.busInfo.layout_id === "") {
          check = false
          this.error_message.layout_id.push('* ' + this.$t('bus.form_is_required'))
        }
        this.error_message.available_seats = []
        if (this.busInfo.available_seats == 0) {
          check = false
          this.error_message.available_seats.push('* ' + this.$t('bus.total_allowed_seats_is_required'))
        }

        this.error_message.license_plate = []
        if (this.busInfo.license_plate === "") {
          check = false
          this.error_message.license_plate.push('* ' + this.$t('bus.license_plate_is_required'))
        }

        return check
      }
    }
  }
</script>

<style scoped>

</style>